import { Button, Header as HeaderComponent } from "frno-react";
import { useLayout } from "../hooks/useLayout";

const Header = () => {
  const { data: layout, isLoading, error } = useLayout();

  if (isLoading) {
    return null;
  }
  if (error) {
    console.error("Error loading layout:", error.message);
    return null;
  }

  return (
    <HeaderComponent
      logo="/wp-content/themes/frweb22/dist/forbrukerradet_logo.svg"
      logoSmall="/wp-content/themes/frweb22/dist/forbrukerradet_logo_symbol.svg"
      expandableMenuColumns={layout?.nav?.mega_menu}
      homeLink="/"
    >
      {layout?.nav?.container.map((item, i) => (
        <Button
          key={i}
          href={item.url}
          className={`${item.classList ?? ""} button-default`}
        >
          {item.title}
        </Button>
      ))}
    </HeaderComponent>
  );
};

export default Header;
